module.exports = __webpack_public_path__ + "static/media/cancel.6791a224.svg";